import { configureStore } from '@reduxjs/toolkit';
import resourcesReducer from './getResourcesSlice';
import cropNutritionReducer from './getCropNutritionSlice';
import oneCropNutritionReducer from './getOneCropNutritionSlice';
import trialResultsReducer from './getTrialResultsSlice';
import oneTrialResultReducer from './getOneTrialResultSlice';
import careerReducer from './getCareerSlice';
import jobsReducer from './getJobsSlice';
import newsReducer from './getNewsSlice';
import articlesReducer from './getArticlesSlice';
import homepageReducer from './getHomepageSlice';

export const store = configureStore({
    reducer: {
        resources: resourcesReducer,
        cropNutrition: cropNutritionReducer,
        oneCropNutrition: oneCropNutritionReducer,
        trialResults: trialResultsReducer,
        oneTrialResult: oneTrialResultReducer,
        career: careerReducer,
        jobsState: jobsReducer,
        news: newsReducer,
        articlesState: articlesReducer,
        homepage: homepageReducer,
    },
});

export default store;
